import { render, staticRenderFns } from "./AddInventory.vue?vue&type=template&id=1cfffead&scoped=true"
import script from "./AddInventory.vue?vue&type=script&lang=js"
export * from "./AddInventory.vue?vue&type=script&lang=js"
import style0 from "./AddInventory.vue?vue&type=style&index=0&id=1cfffead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfffead",
  null
  
)

export default component.exports